import ReCorePageShopCart from './cart'
Vue.component(ReCorePageShopCart.name, ReCorePageShopCart)

import ReCorePageShopBuyGiftCard from './giftcard/buy'
Vue.component(ReCorePageShopBuyGiftCard.name, ReCorePageShopBuyGiftCard)

import ReCorePageShopBuyPlayCard from './playcard/buy'
Vue.component(ReCorePageShopBuyPlayCard.name, ReCorePageShopBuyPlayCard)

import ReCorePageReloadACard from './playcard/reload'
Vue.component(ReCorePageReloadACard.name, ReCorePageReloadACard)

export default {
  ReCorePageShopCart,
  ReCorePageShopBuyGiftCard,
  ReCorePageShopBuyPlayCard,
  ReCorePageReloadACard,
}
